// extracted by mini-css-extract-plugin
module.exports = {"xmlViewerXslt":"xmlviewerxslt_xmlViewerXslt__10r2Q"};